// Matches the legacy `SB` atom. Wraps Badge with severity color mapping.

import { Badge } from "./Badge";

interface SeverityMeta {
  c: string; // foreground
  b: string; // background
  l: string; // label
}

export const SEVERITY_META: Record<string, SeverityMeta> = {
  critical: { c: "rgb(var(--color-critical))", b: "rgb(var(--color-critical-bg))", l: "CRIT" },
  high: { c: "rgb(var(--color-danger))", b: "rgb(var(--color-danger-bg))", l: "HIGH" },
  medium: { c: "rgb(var(--color-warning))", b: "rgb(var(--color-warning-bg))", l: "MED" },
  low: { c: "rgb(var(--color-accent))", b: "rgb(var(--color-accent-bg))", l: "LOW" },
  informational: { c: "rgb(var(--color-muted))", b: "rgb(var(--color-bg3))", l: "INFO" },
};

export function SeverityBadge({ severity }: { severity: string }) {
  const meta = SEVERITY_META[severity] ?? SEVERITY_META.informational;
  return (
    <Badge color={meta.c} bg={meta.b}>
      {meta.l}
    </Badge>
  );
}
